import {Component, ElementRef, EventEmitter, HostListener, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {IImageUpload} from '../interface/upload.interface';
import {ImageService} from '../image.service';
import {MatTabChangeEvent} from '@angular/material/tabs';
export interface SelectedImages {
  id: number;
  imagePath: string;
  imageAlt: string;
}

export enum ModalTab {
  upload,
  gallery,
  collage,
  image_parser,
  crop
}




@Component({
  selector: 'lib-modal',
  template: `<mat-tab-group class="demo-tab-group" (selectedTabChange)="changeTab($event)">
    <mat-tab label="Tab 1">
      <ng-template mat-tab-label>Upload<mat-icon>cloud_upload</mat-icon></ng-template>
      <div class="demo-tab-content">
        <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)" [multiple]="multiple">
          <ngx-dropzone-label class="dropzone-label">
            <div>
              <h2>Кликните чтобы загрузить изображение
                <mat-icon>cloud_upload</mat-icon>
              </h2>
            </div>
          </ngx-dropzone-label>
        </div>


        <div class="myDropzone">
          <ngx-dropzone-image-preview #dropzoneComponent ngProjectAs="ngx-dropzone-preview"
                                      *ngFor="let f of files" [file]="f" [removable]="true"
                                      (removed)="onRemove(f)">
            <ngx-dropzone-label class="dropzone-label">
              <input placeholder="Favorite food" value="Sushi" [value]="f.name.split('.')[0]">
            </ngx-dropzone-label>
          </ngx-dropzone-image-preview>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Tab 2">
      <ng-template mat-tab-label>Gallery
        <mat-icon>image_search</mat-icon>
      </ng-template>
      <div class="demo-tab-content ">
        <input type="text" class="form-control" id="title_ru" aria-describedby="title_ru" name="title_am"
               placeholder="Enter title am" #searchStr (keyup)="search($event)" [(ngModel)]="imageStr">
        <div class="mainGallery">
          <div *ngFor="let image of images" class="modalGallery" (scroll)="onScroll($event)" #img
               (click)="onSelectGalleryImg(img,image.id,image.image_path,image.image_alt)">
            <img src="/upload/{{image.image_path}}" alt="{{image.image_alt}}" width="250px">
            <p>{{image.image_alt}}</p>
          </div>
        </div>


      </div>
    </mat-tab>
    <mat-tab label="Tab 3">
      <ng-template mat-tab-label>
        collage
        <mat-icon>view_compact</mat-icon>
      </ng-template>
      No content
    </mat-tab>
    <mat-tab label="Tab 4">
      <ng-template mat-tab-label>
        Image Parser
        <mat-icon>save_alt</mat-icon>
      </ng-template>
      <div class="demo-tab-content">
        <form>

          <div class="form-group">
            <label for="youtube_link">Youtube url</label>
            <input type="text" class="form-control" id="youtube_link" name="youtube_link"
                   placeholder="Enter youtube_link " [(ngModel)]="youtubeLink" (change)="youtubeLinkFunc()">
            <br>
            <img [src]="youtubeImageUrl" width="300" alt="">
          </div>
        </form>


      </div>
    </mat-tab>
    <mat-tab label="Tab 5">
      <ng-template mat-tab-label>crop<mat-icon>crop</mat-icon></ng-template>
      No content
    </mat-tab>

  </mat-tab-group>
  <div style="text-align: right">
    <button mat-raised-button color="accent" (click)="uploadImages()" [mat-dialog-close]="true">Загрузить изображения </button>
  </div>`,
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
  files: File[] = [];
  images: IImageUpload[] = [];
  imageStr = '';
  @ViewChild('searchStr', {static: true}) searchStr: ElementRef;
  selectedImages: SelectedImages[] = [];
  @ViewChild('dropzoneComponent', {static: true}) dropzoneContainer;
  @Output() OnImages = new EventEmitter<any[]>();
  modalActiveTab: ModalTab = ModalTab.upload;
  multiple = true;
  youtubeLink = '';
  youtubeImageUrl = '';

  constructor(
      private imageService: ImageService,
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<ModalComponent>, @Inject(MAT_DIALOG_DATA) data
  ) {
    this.multiple = data.multiple;
  }

  onSelect(event): void {
    if (!this.multiple && this.files.length > 0) {
      this.files = [];
    }
    this.files.push(...event.addedFiles);
  }

  onRemove(event): void {
    this.files.splice(this.files.indexOf(event), 1);
  }

  ngOnInit(): void {}

  uploadImages(): void {
    switch (this.modalActiveTab) {
      case ModalTab.upload:
        this.imageService.saveImages(this.files).subscribe(uploadFiles => this.OnImages.emit(uploadFiles));
        break;
      case ModalTab.gallery:
        this.listPhotos();
        break;
      case ModalTab.collage:
        break;
      case ModalTab.image_parser:
        this.imageService.saveImagesByUrl({
          file_name: '',
          file_path: this.youtubeImageUrl
        }).subscribe(uploadFiles => this.OnImages.emit(uploadFiles));
        break;
      case ModalTab.crop:
        break;
      default:
        this.imageService.saveImages(this.files).subscribe(uploadFiles => this.OnImages.emit(uploadFiles));
        break;
    }
  }


  pastImages(): void {
    this.OnImages.emit(this.selectedImages);
  }

  changeTab($event: MatTabChangeEvent): void {
    switch ($event.index) {
      case ModalTab.upload:
        console.log('ModalTab.upload', ModalTab.upload);
        this.modalActiveTab = ModalTab.upload;
        break;
      case ModalTab.gallery:
        this.modalActiveTab = ModalTab.gallery;
        this.listPhotos();
        break;
      case ModalTab.collage:
        this.modalActiveTab = ModalTab.collage;
        break;
      case ModalTab.image_parser:
        console.log('ModalTab.image_parser', ModalTab.image_parser);
        this.modalActiveTab = ModalTab.image_parser;
        break;
      case ModalTab.crop:
        this.modalActiveTab = ModalTab.crop;
        break;
      default:
        this.modalActiveTab = ModalTab.upload;
        break;
    }

  }

  listPhotos(): void {
    this.imageService.fetchList().subscribe((result: IImageUpload[]) => {
      this.images = result;
    });
  }

  search($event: KeyboardEvent): void {
    this.imageService.searchImages(this.searchStr.nativeElement.value).subscribe((result: IImageUpload[]) => {
      this.images = result;
    });
  }

  @HostListener('window:scroll', ['$event'])

  onScroll($event: Event): void {
    // this.scrollHeight - this.scrollTop - this.clientHeight <= 500
    console.log('----e---', $event);
  }

  onSelectGalleryImg($event, id: number, imagePath: string, imageAlt: string): void {
    const obj: SelectedImages = {id, imagePath, imageAlt};
    if ($event.classList.contains('selectedImg')) {
      $event.classList.remove('selectedImg');
      delete this.selectedImages[this.selectedImages.indexOf(obj)];
    } else {
      $event.classList.add('selectedImg');
      this.selectedImages.push(obj);
    }
  }

  youtubeLinkFunc(): void {
    let youtubeVideoId = '';
    if (this.youtubeLink.includes('https://youtu.be')) {
      youtubeVideoId = this.youtubeLink.trim().slice(17, 28);
    } else if (this.youtubeLink.includes('https://www.youtube.com/watch?v=')) {
      youtubeVideoId = this.youtubeLink.trim().slice(32, 43);
    }
    if (youtubeVideoId) {
      this.youtubeImageUrl = `https://i.ytimg.com/vi/${youtubeVideoId}/maxresdefault.jpg`;
    }
  }

}
